import * as Yup from "yup";
import { PessoaFormModel } from "../../../modelos/pessoa/pessoaFormModel";

export const CadastroMotoristaSchema: Yup.SchemaOf<PessoaFormModel> =
  Yup.object().shape({
    id: Yup.string().notRequired(),
    nome: Yup.string().required("Item obrigatório"),
    email: Yup.string().nullable().notRequired(),
    telefone: Yup.string().required("Item obrigatório"),
    cpf: Yup.string().notRequired(),
    documento: Yup.mixed().notRequired(),
    sexo: Yup.mixed().notRequired(),
    perfil: Yup.mixed().notRequired(),
    idEmpresa: Yup.mixed().required("Item obrigatório"),
    idAcompanhante: Yup.mixed().notRequired(),
    maiorDeIdade: Yup.mixed().notRequired(),
    tipoDocumento: Yup.mixed().notRequired(),
  });
